import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';

export const PasswordPolicy = () => {
  const { t } = useTranslation();
  return (
    <Styled>
      <Icon name="idea" />
      <Trans i18nKey="ui.password.hint">
        <a
          href={t('ui.password.zendeskSupportUrlForPassword')}
          rel="noopener noreferrer"
          target="_blank"
        ></a>
      </Trans>
    </Styled>
  );
};

const Styled = styled.div`
  margin: 0.75em 0 4em;
  font-size: 0.9em;

  .password-canUseSymbols {
    text-indent: 1.25em;
  }
`;
